import { useEffect, useRef } from "react";
import Player from "@vimeo/player";

const parseVimeoUrl = (rawUrl) => {
    if (!rawUrl) return null
    try {
        const url = new URL(rawUrl)
        const segments = url.pathname.split('/').filter(Boolean)
        const videoSegmentIndex = segments.findIndex((s) => /^\d+$/.test(s))
        if (videoSegmentIndex === -1) return null
        const id = segments[videoSegmentIndex]
        const hashFromPath = segments[videoSegmentIndex + 1] && !/^\d+$/.test(segments[videoSegmentIndex + 1])
            ? segments[videoSegmentIndex + 1]
            : null
        const hashFromQuery = url.searchParams.get('h')
        return { id, h: hashFromPath || hashFromQuery || null }
    } catch {
        return null
    }
}

const buildEmbedUrl = ({ id, h }) => {
    const params = new URLSearchParams({
        dnt: '1',
        title: '0',
        byline: '0',
        portrait: '0',
        pip: '0',
        playsinline: '1',
    })
    if (h) params.set('h', h)
    return `https://player.vimeo.com/video/${id}?${params.toString()}`
}

export default function VimeoPlayerInline({ videoUrl, poster }) {

    const containerRef = useRef(null)
    const playerRef = useRef(null)

    useEffect(() => {
        if (!videoUrl || !containerRef.current) return

        const parsed = parseVimeoUrl(videoUrl)
        if (!parsed) return

        const iframe = document.createElement('iframe')
        iframe.src = buildEmbedUrl(parsed)
        iframe.allow = 'autoplay; fullscreen; encrypted-media'
        iframe.allowFullscreen = true
        iframe.style.width = '100%'
        iframe.style.height = '100%'
        iframe.style.border = '0'
        iframe.style.position = 'absolute'
        iframe.style.top = '0'
        iframe.style.left = '0'

        containerRef.current.innerHTML = ''
        containerRef.current.appendChild(iframe)

        playerRef.current = new Player(iframe)

        return () => {
            if (playerRef.current) {
                playerRef.current.destroy().catch(() => {})
                playerRef.current = null
            }
        }
    }, [videoUrl])

    const blockContextMenu = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    return (
        <section className="video_player_inline">
            <div
                ref={containerRef}
                onContextMenu={blockContextMenu}
                onDragStart={blockContextMenu}
                style={{
                    position: 'relative',
                    width: '100%',
                    paddingTop: '56.25%',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    WebkitTouchCallout: 'none',
                }}
            />
        </section>
    )
}
